<template>
  <PagesSlugComponent
    v-if="data"
    :data="data"
  />
  <SharedErrorComponent v-else-if="error" :error="error" />
</template>

<script lang="ts" setup>
const route = useRoute()

// 1
useHead({
  htmlAttrs: { 'data-page-type': 'slug' }
})

// 2
const queryOptions = baseStrapiGetSlugQueryObjectFromRoute()
const { data, error } = await useAsyncData(`slug-${route.params.slug}`, () =>
  fetchQueryPath( queryPageEntryBySlug(queryOptions) )
)

if (!data?.value?.data?.length || error.value) {
  throw createError({
    statusCode: 500,
    statusMessage: 'Page not found',
    stack: ''
  })
}

basePageSetHead(data)
</script>
